<script setup lang="ts">
import { onMounted } from 'vue';
import { useOneTap } from '@/components/Google/use-one-tap';
import WelcomeBanner from '@/components/signIn/WelcomeBanner.vue';
import SignInForm from '@/components/signIn/SignInForm.vue';
import { trackEvent } from '@/utils/analytics';
import BrandSign from '@/assets/icons/brand_sign.svg';

useOneTap();
onMounted(() => {
  trackEvent('Sign in page view');
});
</script>

<template>
  <div class="min-h-full bg-gradient-sign-in">
    <div class="sign-in flex flex-col w-full max-md:pb-4">
      <div
        class="flex justify-center sm:justify-start items-center w-full px-[60px] py-[40px] relative"
      >
        <Icon :src="BrandSign" class="text-primary w-[22px] h-[32px]" />
      </div>
      <div
        class="sign-in__content flex justify-space-between align-center w-full max-w-[1440px] mx-auto"
      >
        <WelcomeBanner />
        <h3
          class="lg:hidden text-center font-bold text-2xl sm:text-[40px] order-1"
        >
          Welcome to Noty.ai
        </h3>
        <div class="w-full sm:max-w-[427px] order-2">
          <SignInForm />
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.sign-in__content {
  @apply flex-col gap-y-8 px-4;
  @apply md:px-[64px];
  @apply lg:flex-row lg:px-[80px];
  @apply xl:px-[200px];
}
</style>
